import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faScaleBalanced,
  faHeadset,
  faHandshake,
  faLifeRing,
} from "@fortawesome/free-solid-svg-icons";

import "./Our_Commitment.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const OurCommitment = () => {
  const commitments = [
    {
      icon: faScaleBalanced,
      text: "100% legal and transparent recruitment",
    },
    {
      icon: faHeadset,
      text: "Dedicated support throughout the process",
    },
    {
      icon: faHandshake,
      text: "Client satisfaction as our priority",
    },
    {
      icon: faLifeRing,
      text: "Post-deployment support",
    },
  ];

  return (
    <section className="our_commitment_section">
      <Container>
        <div className="our_commitment_content">
          <CommonHeading title="Our Commitment" />

          <Row className="g-2">
            {commitments.map((item, index) => (
              <Col md={3} sm={6} key={index}>
                <div className="our_commitment_item">
                  <FontAwesomeIcon
                    icon={item.icon}
                    className="our_commitment_icon"
                  />

                  <span className="our_commitment_text">
                    {item.text}
                  </span>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default OurCommitment;